module.exports = __webpack_public_path__ + "resources/img/img_passxpertv4_2_m.f291ef1ad53e0ba208c58e3d2d492fd2.png";